import TopContent from 'components/FrictionlessCheckout/TopContent/TopContent';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import TopContentEN from 'components/FrictionlessCheckout/TopContent/locales/TopContent_en_US';
import TopContentFR from 'components/FrictionlessCheckout/TopContent/locales/TopContent_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(TopContentEN, TopContentFR);
const { wrapHOC } = FrameworkUtils;

const localization = createStructuredSelector({
    freeReturns: getTextFromResource(getText, 'freeReturns'),
    verifyCVVeFulfilledOrder: getTextFromResource(getText, 'verifyCVVeFulfilledOrder'),
    verifyCVV: getTextFromResource(getText, 'verifyCVV'),
    noPaymentRequired: getTextFromResource(getText, 'noPaymentRequired')
});

const fields = createSelector(localization, locale => {
    return {
        localization: locale
    };
});

const withTopContentProps = wrapHOC(connect(fields, null));

export default withTopContentProps(TopContent);
